// extracted by mini-css-extract-plugin
module.exports = {"link":"_3WGOvs","list":"_29xhsk","media":"_5dQ1xu","body":"sarMl-","sliderTrack":"_34Gb4M","item":"vEfW3-"};